define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/Relationship",
	"csi/html/View",
	"csi/reflection",
	"csi/util"
], function(declare, lang, Relationship, HtmlView, reflection, util) {

	return declare(HtmlView, {
		_types: ["Gallery", "Html"],

		defaultImageSize: reflection.IMAGE_SIZE_MEDIUM,

		constructor: function(def) {
			this.m_relationship = util.getDef(def, "Relationship", Relationship);

			// Boolean: Indicates whether to enable the Plot Nodes by Rows and Columns option in the preferences of the gallery view. (Story: S7600).
			this.m_plot = util.getBooleanProperty(def, "Plot", false);
		},

		getPageRelationship: function() {
			return this.m_relationship;
		},

		getRelationships: function() {
			return this.m_relationship ? [this.m_relationship] : [];
		},

		isPlotOptionEnabled: function() {
			return this.m_plot;
		},

		resolve: function(/*Class*/rcRoot, /*Node*/nodeRoot, /*Boolean*/bConfigure) {
			// resolve relationship and view
			var lmap = this.getLocaleMap(rcRoot, bConfigure);

			this.m_relationship?.resolve(lmap, rcRoot, nodeRoot);
			this.inherited(arguments);

			// restrict view actions if being used for selection
			if (this.isReadOnly() || (this.m_formData && !this.m_formData.m_bEditable)) {
				this.m_relationship?.resetActions();
			}

			return lmap;
		}
	});
});